import apiClient from "./client";

/** 数据概览 KPI 指标 */
export interface OverviewKpis {
  totalAgents: number;
  activeAgents: number;
  totalMaterials: number;
  periodViews: number;
  periodDownloads: number;
}

/** 活动趋势数据点 */
export interface ActivityTrendPoint {
  timeSlot: string;
  views: number;
  downloads: number;
}

/** 代理商活动排行条目 */
export interface AgentActivityRankItem {
  userId: string;
  name: string;
  company: string;
  region: string;
  views: number;
  downloads: number;
  lastActive: number;
}

/** 热门资料排行条目 */
export interface HotMaterialItem {
  materialId: string;
  title: string;
  type: string;
  category: string;
  views: number;
  downloads: number;
}

/** 时间筛选类型 */
export type TimeFilter = "today" | "7days" | "30days" | "1year" | "all";

/**
 * 获取数据概览 KPI 指标
 * POST /agentstat/getOverviewKpis.do
 */
export async function getOverviewKpis(timeFilter: TimeFilter): Promise<OverviewKpis> {
  const formData = new URLSearchParams();
  formData.append("timeFilter", timeFilter);
  const res = await apiClient.post("/agentstat/getOverviewKpis.do", formData.toString());
  const d = res.data;
  if (d && d.success) {
    return d.data as OverviewKpis;
  }
  throw new Error(d?.info || "获取KPI数据失败");
}

/**
 * 获取活动趋势数据
 * POST /agentstat/getActivityTrend.do
 * 今日返回24小时数据，其他返回每日数据
 */
export async function getActivityTrend(timeFilter: TimeFilter): Promise<ActivityTrendPoint[]> {
  const formData = new URLSearchParams();
  formData.append("timeFilter", timeFilter);
  const res = await apiClient.post("/agentstat/getActivityTrend.do", formData.toString());
  const d = res.data;
  if (d && d.success) {
    return (d.data as { data: ActivityTrendPoint[] }).data || [];
  }
  throw new Error(d?.info || "获取活动趋势失败");
}

/**
 * 获取代理商活动排行
 * POST /agentstat/getAgentActivityRank.do
 */
export async function getAgentActivityRank(timeFilter: TimeFilter): Promise<AgentActivityRankItem[]> {
  const formData = new URLSearchParams();
  formData.append("timeFilter", timeFilter);
  const res = await apiClient.post("/agentstat/getAgentActivityRank.do", formData.toString());
  const d = res.data;
  if (d && d.success) {
    return (d.data as { data: AgentActivityRankItem[] }).data || [];
  }
  throw new Error(d?.info || "获取代理商排行失败");
}

/**
 * 获取热门资料排行
 * POST /agentstat/getHotMaterials.do
 */
export async function getHotMaterials(timeFilter: TimeFilter): Promise<HotMaterialItem[]> {
  const formData = new URLSearchParams();
  formData.append("timeFilter", timeFilter);
  const res = await apiClient.post("/agentstat/getHotMaterials.do", formData.toString());
  const d = res.data;
  if (d && d.success) {
    return (d.data as { data: HotMaterialItem[] }).data || [];
  }
  throw new Error(d?.info || "获取热门资料失败");
}
